import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@coin/shared/auth/data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { AnimIconComponent } from '@coin/shared/core/feature-legacy-components';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-siemens-energy-logout-screen',
  templateUrl: './logout-screen.component.html',
  styleUrls: ['./logout-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AnimIconComponent, V2ButtonComponent, TranslatePipe]
})
export class LogoutScreenComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  ngOnInit(): void {
    this.authService.logOff();
  }

  login(): void {
    this.router.navigate(['/']);
  }
}
